import { BoxProps } from "@mui/material";
import { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import DostLogo from "src/assets/logo/newDostLogoWithoutText.png";
import DostSageLogo from "src/assets/logo/DostSageLogo.svg";
import { CustomTheme } from "src/@types/customTheme";
import { RootState, useSelector } from "@redux/store";

import newDostLogo from "../assets/logo/newDostDarkLogo.png";
import { AuthContext } from "../contexts/JWTContext";

interface Props extends BoxProps {
  disabledLink?: boolean;
  isCollapse?: boolean;
}

export default function Logo({ disabledLink = false, isCollapse, sx }: Props) {
  const context = useContext(AuthContext);
  const customLogo = localStorage.getItem("customLogo");
  const customTheme = useSelector(
    (state: RootState) => state.accountInfo.accountInfo?.customTheme,
  );
  const showSageBranding = customTheme === CustomTheme.Sage;

  const logo =
    customLogo && context?.isAuthenticated ? (
      <img src={customLogo} style={{ width: "70px" }} />
    ) : isCollapse ? (
      <img
        src={DostLogo}
        alt="Dost Logo"
        height={"44px"}
        width={"44px"}
        style={{ position: "relative", bottom: "4px" }}
      />
    ) : (
      <img
        src={showSageBranding ? DostSageLogo : newDostLogo}
        style={{ width: showSageBranding ? "180px" : "100px" }}
      />
    );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
